import { getItemOrDefaultToValue, getPersonName } from '../../details';
export const transform = list => {
  return list.map(data => ({
    id: data.id,
    accountHolder:
      data.contact !== null ? getPersonName(data.contact.general) : '-',
    services: getItemOrDefaultToValue(data, 'services', '-'),
    themes: getItemOrDefaultToValue(data, 'themes', []),
    securityCompany: getItemOrDefaultToValue(data, 'name', '-'),
    accountHolderEmail: data.contact.general.email || '-',
    accountHolderPhone:
      data.contact.general.phoneNumber !== null
        ? `${data.contact.general.phoneNumber.prefix} ${data.contact.general.phoneNumber.number}`
        : '-',
    regionName: getItemOrDefaultToValue(data, 'regionName', '-'),
    numManagers: data.resourceCount.managers,
    numSupervisors: data.resourceCount.supervisors,
    numResponders: data.resourceCount.responders,
    numGuards: data.resourceCount.guards,
    numDrivers: data.resourceCount.drivers,
    numCleaners: data.resourceCount.cleaners,
    numMaintainers: data.resourceCount.maintainers,
    numSites: data.resourceCount.sites,
  }));
};
